import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"
import { useMemo } from "react"
import { useFormContext } from "react-hook-form"
import { SideNavItem } from "../SideNavItem"
import { getSectionStatus } from "../../utils/getSectionStatus"
import { useSectionState } from "../../context/SectionContextProvider"
import { FormSection } from "../../types/FormSection"
import { useGetFormByProvince } from "../../hooks/useGetFormByProvince"
import { Section } from "../../types/SectionState"

const getSectionData = (order: number = 0, data?: FormSection[]) => {
  return data?.[order - 1]
}

export function SideNav() {
  const { step, province } = useParams<{ step: string; province: string }>()
  const currentStep = Number(step)
  const { t } = useTranslation()
  const { data } = useGetFormByProvince(province ?? "ontario")
  const methods = useFormContext()
  const sectionState = useSectionState()

  const sections = useMemo(() => Object.values(sectionState), [sectionState])

  const skipConditionalSection = (section: Section) => {
    const sectionData = getSectionData(section.order, data)
    if (sectionData) {
      const { conditional_section_mapped_field, conditional_section_values } =
        sectionData
      if (conditional_section_mapped_field && conditional_section_values) {
        const values = methods.getValues(conditional_section_mapped_field)
        if (
          conditional_section_values &&
          !conditional_section_values.includes(values)
        )
          return true
      }
    }
    return false
  }

  return (
    <aside
      id="navigation"
      className="flex w-full md:w-1/2 h-full pr-12 h-auto sticky self-start md:top-20 md:overflow-y-auto"
    >
      <div className="flex pt-12 w-full md:pl-28 pl-10">
        <div className="flex flex-col">
          <div className="flex">
            <h2 className="pb-[56px] [font-family:var(--alias-font-display-lg-font-family)] [font-size:var(--alias-font-display-lg-font-size)]">
              {t("client.sideNav.title")}
            </h2>
          </div>
          {sections.map((section, index) => {
            const isCurrentSection = step ? currentStep === index + 1 : false
            const status = getSectionStatus(section, isCurrentSection)
            if (skipConditionalSection(section)) return <></>
            return (
              <div
                key={section.name + index}
                data-testid={"side_nav_item" + section.name + index}
              >
                <SideNavItem
                  to={`/${province}/steps/${index + 1}`}
                  tooltip={section.name}
                  status={status}
                >
                  {section.name}
                </SideNavItem>
              </div>
            )
          })}
        </div>
      </div>
    </aside>
  )
}
